// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"App_Dashboard__uEWrP","Copyright":"App_Copyright__3jSGH"};